import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Users } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';
import { UnifiedHeader } from '../components/layout/UnifiedHeader';
import { SEO } from '../components/seo/SEO';
import { PAGE_META } from '../config/seo';

const HomePage: React.FC = () => {
  const { isAuthenticated } = useAuth();

  return (
    <div className="min-h-screen bg-surface-0">
      <SEO title={PAGE_META['/'].title} description={PAGE_META['/'].description} path="/" />
      <UnifiedHeader />

      {/* Hero Section */}
      <section className="relative min-h-[calc(100vh-4rem)] flex items-center justify-center overflow-hidden mt-16">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-black/50 z-10"></div>
          <div
            className="w-full h-full bg-cover bg-center"
            style={{
              backgroundImage: "url('/images/family-hero.jpeg')",
              backgroundPosition: '50% 80%'
            }}
          ></div>
        </div>

        <div className="relative z-20 text-center max-w-6xl px-4 sm:px-6 lg:px-8">
          <h1 className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-8xl mb-6 text-white leading-tight">
            Redd Family Association
          </h1>

          <p className="text-lg sm:text-xl md:text-2xl text-white/90 mb-12 max-w-3xl mx-auto">
            A family that prays together, stays together
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link
              to={isAuthenticated ? "/home" : "/login"}
              className="bg-white text-text-primary px-8 py-4 rounded-md text-lg font-semibold transition-colors duration-150 hover:bg-white/90 flex items-center space-x-3"
            >
              <Users className="w-6 h-6" />
              <span>Access Family Portal</span>
            </Link>

            <Link
              to="/donations"
              className="bg-amber-600 text-white px-8 py-4 rounded-md text-lg font-semibold transition-colors duration-150 hover:bg-amber-700 flex items-center space-x-3"
            >
              <Heart className="w-6 h-6" />
              <span>Donate</span>
            </Link>

            <Link
              to="/about"
              className="border-2 border-white text-white px-8 py-4 rounded-md text-lg font-semibold transition-colors duration-150 hover:bg-white/10 flex items-center space-x-3"
            >
              <Heart className="w-6 h-6" />
              <span>Our Family Story</span>
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-surface-1 border-t border-border py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h3 className="font-display text-2xl mb-3 text-text-primary">
            The Redd Family Association
          </h3>
          
          <p className="text-text-secondary text-base mb-6 italic max-w-2xl mx-auto">
            A family that prays together, stays together
          </p>
          
          <p className="text-text-tertiary text-sm">
            &copy; {new Date().getFullYear()} The Redd Family Association. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export { HomePage };
